import { useState } from 'react';
import { Row, Col, DotLoader, Button, Modal, P1, P2, ModalFooterWithConfirmation, B1 } from 'pfm-ui-components';
import { down, up } from 'styled-breakpoints';
import { NomineeDetails, ProfileDetails } from '../../portfolio/profile';
import styled from 'styled-components';
import Container from '../../../components/common/Container';
import { pxToRem } from '../../../styles/utils';
import InvestPage from '../../../components/modules/transact/InvestPage';
import { useHeaderHeight } from '../../../components/common/Header';
import BackButton from '../../../components/common/BackButton';
import * as constants from '../../../constants/investTransactPage';
import Footer from '../../../components/common/Footer';
import { useRouter } from 'next/router';
import API from '../../../API';
import { useEffect } from 'react';
import { convertArrayOfObjectToObject } from '../../../utils/common';
import TransactionSuccessCard from '../../../components/common/TransactionSuccessCard';
import { getDateOrdinal } from '../../../utils/date';
import * as errorMessage from '../../../constants/ErrorMessages';
import { BACK, Months } from '../../../constants/common';
import {
  EXPLORE_SCHEMES_USER_FLOW,
  JOINT_INVESTMENT_ID_ERROR,
  SAVE_TAX_SUB_CAT,
  SECONDARY_HOLDER_INVESTMENT_ID_ERROR,
} from '../../../constants/ExplorePage';
import FullPageLoader from '../../../components/common/FullPageLoader';
import { routes } from '../../../config/routes';
import { setTransactionId, unsetTransactionId } from '../../../API/utils';
import GTM from '../../../GTM';
import { useAppContext } from '../../../store';
import {
  triggerActionButtonsClickGtmEvent,
  triggerAddNomineeGtmEvent,
  triggerCloseOtpModalGtmEvent,
  triggerContinueClickGtmEvent,
  triggerEditNomineeGtmEvent,
  triggerGoBackMessageClickGtmEvent,
  triggerNomineeModalActionGtmEvent,
  triggerNomineeModalPageLoadGtmEvent,
  triggerOnBackGtmEvent,
  triggerOnPageLoadGtmEvent,
  triggerOtpModalPageLoadGtmEvent,
  triggerSubmitOtpModalGtmEvent,
  triggerTermsAndConditionGtmEvent,
  triggerTransactionSuccessPageLoadGtmEvent,
} from '../../../components/modules/transact/InvestPage/gtmUtil';
import { CLOSE, SUBMIT } from '../../../constants/OtpModal';
import { ADD_ANOTHER_NOMINEE, CONFIRM_DETAILS } from '../../../constants/NomineeModal';
import { REMOVE } from '../../../constants/SwitchTransaction';
import { getIconForNavigationTab } from '../../../components/common/NavigationFooterTab/util';
import {
  DUPLICATE_FUND_ERROR,
  DIFFERENT_INVESTMENTID_ERROR,
  MAX_NUMBER_OF_SCHEMES_ALREADY_ADDED,
} from '../../../constants/CartPage';
import Link from 'next/link';
import { CartProps } from '../../../components/modules/cart/CartPage';
import { HUF_INVEST_NOW_ERROR_MESSAGE } from '../../../constants/ErrorMessages';

export interface FolioListProps {
  folioNumber: string;
  minAmount: number;
  investmentTimeFrame: string;
}

export interface FundOption {
  planType: string;
  fundId: string;
  fundName: string;
}

export interface InvestFrequency {
  displayName: string;
  minSipAmount: number;
  minStepSipAmount: number;
  minSipInstallment: number;
  preferredDates: Array<string>;
  minimumUnits: number;
  minimumStepUnits: number;
}
export interface BuyDetailsProps {
  constitutionCode: string;
  isShowOneTime: boolean;
  isShowMonthlySip: boolean;
  folioList: Array<FolioListProps>;
  preferredDates: Array<string>;
  sipFrequencies: Array<InvestFrequency>;
  maxNominee: number;
  maximumTimeHorizon: string;
  minAmount: number;
  minStepAmount: number;
  minSipAmount: number;
  minStepSipAmount: number;
  minSipInstallment: number;
  fundName: string;
  latestNavDate: string;
  latestNav: number;
  accountHolder: string;
  acHolderDateOfBirth: any;
  dividendOptions: Array<string>;
  isAxisSelect: boolean;
  customerRiskProfile: string;
  fundHouseId: string;
  fundRiskProfile: string;
  fundSubCategory: string;
  investmentTimeframe: string;
  valueDate: string;
  fundCategory: string;
  fundOptions?: Array<FundOption>;
  defaultNominees?: Array<any>;
  nomineeFromPreviousInvestment?: Array<any>;
  orderId?: string;
  newNominee?: string;
}

export interface BankDetails {
  acctName: string;
  acctId: string;
  availableBalance: string;
}

export interface InvestmentIdDetails {
  cif_id: string;
  isMinor: string;
  name: string;
  inv_ID: string;
  second_Holder_Name: string;
  third_Holder_Name?: string;
  whetherMFTransactionAllowed: string;
  risk_PROFILE_CTGRY: string;
  isProfileExpired: string;
  investmentAccountMismatch: string;
  inv_Status: string;
  mode_of_oper_ac: string;
  isHUF?: string;
  isUboApplicable?: boolean;
  fatca_AVAILABLE?: string;
  isSoleProp?: string;
  kycStatus?: string;
}

export interface TransactionRequestData {
  amount: number;
  folioNum: string;
  investmentId: string;
  noOfInstallment?: number;
  nominees: Array<any>;
  scheduleDate?: string;
  fundCode: string;
  selectedDividendOption: string;
  accountNumber: string;

  investmentTimeframe?: string;
  deviation?: string;
}

export interface RelationShipCodes {
  code: string;
  type: string;
  description: string;
}
interface OtpResponseDetails {
  message: string;
  mobileNo: string;
  emailId: string;
}

interface ResponseStatus {
  statusMessage: string;
  statusType: string;
}

interface OtpResponseData {
  data?: {
    data: OtpResponseDetails;
    status?: ResponseStatus;
  };
}

export interface BuyDetailsData {
  data?: {
    data: BuyDetailsProps;
  };
}

export interface ProfileData {
  data?: {
    data: Array<ProfileDetails>;
  };
}

export interface BankData {
  data?: {
    data: Array<BankDetails>;
  };
}

export interface NomineeValidateData {
  data?: {
    data: Array<NomineeDetails>;
  };
}
export interface InvestmentIdsData {
  data?: {
    data: Array<InvestmentIdDetails>;
  };
}

interface RelationShipCodesData {
  data?: {
    data: Array<RelationShipCodes>;
  };
}

interface LumpsumVerifyOtpData {
  data?: {
    data: {
      mfSubDtlsAutoVerifyRs: {
        transactionId: {
          tranId: string;
          tranDate: string;
        };
      };
    };
  };
}

interface SIPVerifyOtpData {
  data?: {
    data: {
      mfSystPlanAddVerRs: {
        sysPlanID: string;
      };
    };
  };
}
interface CartData {
  investmentId: string;
  cartId: string;
  contents: Array<Object>;
}

interface CartDetails {
  data?: {
    data: {
      investmentId: string;
      cartId: string;
      contents: Array<string>;
    };
  };
}

interface MinorStatusResponseData {
  data?: {
    data: Array<{ investmentId: string; isMinor: string }>;
  };
}

export default function InvestTransactPage() {
  const router = useRouter();
  const {
    hasAlreadyInvested,
    folioNumber,
    fundCode,
    investmentId,
    isSip = false,
    isRenewSip = false,
    isNfo = false,
    userFlow = EXPLORE_SCHEMES_USER_FLOW.EXPLORE, // If no userflow is passed in query param then use explore flow only
    invIdeaScheme,
    fallBackTo,
    lastTransactionId,
    schedule,
    frequency,
    from,
    goal,
  } = router.query;

  const [buyDetails, setBuyDetails] = useState<BuyDetailsProps>();
  const [buyDetailsLoading, setBuyDetailsLoading] = useState(false);
  const [openVerifyOTPModal, setOpenVerifyOTPModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorMessageShownInModal, setErrorMessageShownInModal] = useState('');
  const [otpResponse, setOtpResponse] = useState<OtpResponseDetails>();
  const [transactionRequestData, setTransactionRequestData] = useState<TransactionRequestData>();
  const [bankDetails, setBankDetails] = useState({});
  const [investmentIdsDetails, setInvestmentIdsDetails] = useState<Array<InvestmentIdDetails>>();
  // const buyDetails = constants.BUY_DETAILS;
  const [referenceId, setReferenceId] = useState('');
  const [isTransactionSuccessful, setIsTransactionSuccessful] = useState(false);
  const [isLumpsum, setIsLumpsum] = useState(true);
  const [showPageLoader, setShowPageLoader] = useState(false);
  const [showLoaderAddToCart, setShowLoaderAddToCart] = useState(false);
  const [showLoaderInOtp, setShowLoaderInOtp] = useState(false);
  const [investId, setInvestId] = useState(investmentId as string);
  const [relationShipCodeDetails, setRelationShipCodeDetails] = useState<Array<RelationShipCodes>>();
  const [relationShipCodeObject, setRelationShipCodeObject] = useState({});
  const [fundCodeOptionSelected, setFundCodeOptionSelected] = useState(fundCode);
  const [investmentIdSelected, setInvestmentIdSelected] = useState(investmentId as string);
  const [onOkRedirect, setOnOkRedirect] = useState(false);
  const [errorOccurredInBankApi, setErrorOccurredInBankApi] = useState(false);
  const [errorMessageOfBankApi, setErrorMessageOfBankApi] = useState('');
  const [clearOtp, setClearOtp] = useState(false);
  const headerHeight = useHeaderHeight();
  const { state, setState } = useAppContext();
  const [redirectTo, setRedirectTo] = useState('');
  const [didErrorOccur, setDidErrorOccur] = useState(false);
  const [otpFailureCount, setOtpFailureCount] = useState(0);
  const [onOkOTPRedirect, setOnOkOTPRedirect] = useState(false);
  const [openJointHolderInvestmentErrorModal, setOpenJointHolderInvestmentErrorModal] = useState(false);
  const [stallJointInvestmentIdError, setStallJointInvestmentIdError] = useState<boolean>();
  const [cartData, setCartData] = useState<CartData>();
  const [openTwoButtonCartAlertModal, setOpenTwoButtonCartAlertModal] = useState(false);
  const [openCartAlertModal, setOpenCartAlertModal] = useState(false);
  const [openCartModalForInvestmentId, setOpenCartModalForInvestmentId] = useState(false);
  const [isNomineeError, setIsNoimineeError] = useState<boolean>(false);
  const [openSecondaryHolderInvestmentErrorModal, setOpensecondaryHolderInvestmentErrorModal] = useState(false);
  const [isCustomerMinor, setIsCustomerMinor] = useState(null);
  const [isModeOfOperationSI, setIsModeOfOperationSI] = useState(null);
  const [JointHolderWithoutFolioAndInvestmentModal, setJointHolderWithoutFolioAndInvestmentModal] = useState(false);
  const [IsModeOfOperationSIModal, setIsModeOfOperationSIModal] = useState(false);
  const [errorCode, setErrorCode] = useState<any>();
  const [storedOtp, setStoredOtp] = useState('');
  const [secondTimeOtop, setSecondTimeOtp] = useState(' ');
  const [selectedInvestmentId, setSelectedInvestmentId] = useState<any>();
  const [custId, setCustId] = useState<string>('');
  const [isMultipleInvestmentIds, setIsMultipleInvestmentIds] = useState(false);
  const [minorTurnedMajorCustomErrorModalOpen, setMinorTurnedMajorCustomErrorModalOpen] = useState(false);

  //Check if the existing folio has Nomination (Function to call that API)
  //Store the boolean value in a state (hasNomination, setHasNomination)

  const validateIfCustomerisMinor = (customer) => {
    API.investments.getMinorStatus().then((minorStatusResponseData: MinorStatusResponseData) => {
      if (
        customer.isMinor == 'N' ||
        minorStatusResponseData?.data?.data?.filter(
          (minorStatusObj) => minorStatusObj?.investmentId == customer?.inv_ID
        )?.length == 0
      ) {
        return; // customer has turned major acc to bank records , no need to check if customer turned major from minor
      } else {
        if (
          minorStatusResponseData?.data?.data?.filter(
            (minorStatusObj) => minorStatusObj?.investmentId == customer?.inv_ID
          )[0]?.isMinor == 'Y'
        ) {
          setIsCustomerMinor(true); //actually minor
          setMinorTurnedMajorCustomErrorModalOpen(false);
        } else {
          setIsCustomerMinor(false); //minor turned major
          setMinorTurnedMajorCustomErrorModalOpen(true);
        }
      }
    });
  };

  useEffect(() => {
    if (errorCode === 7011) {
      setOnOkRedirect(true);
      setRedirectTo(routes.MUTUAL_FUND.url);
      setErrorMessageShownInModal(errorMessage.SOMETHING_WHEN_WRONG);
    }
  }, [errorCode]);

  useEffect(() => {
    setTransactionId();
    setOtpFailureCount(0);
    return () => {
      unsetTransactionId();
    };
  }, []);

  useEffect(() => {
    API.cart
      .getCartDetails()
      .then((res: CartDetails) => {
        setCartData(res.data.data);
      })
      .catch((error) => {
        setOpenErrorModal(true);
        setErrorMessageShownInModal(error?.errorMsg?.message);
      });
  }, []);

  const termsAndConditionGtmData = () => {
    triggerTermsAndConditionGtmEvent(userFlow?.toString(), buyDetails?.fundName, invIdeaScheme?.toString());
  };

  const addNomineeGtmData = () => {
    // GTM for when add nominee is clicked
    // triggerAddNomineeGtmEvent(userFlow.toString(), buyDetails?.fundName, invIdeaScheme?.toString());
    // GTM for on load of nominee modal since as soon as add nomine is clicked modal will open
    // triggerNomineeModalPageLoadGtmEvent(userFlow.toString(), buyDetails?.fundName, invIdeaScheme?.toString());
  };

  const editNomineeGtmData = () => {
    // GTM for when Edit nominee is clicked
    // triggerEditNomineeGtmEvent(userFlow.toString(), buyDetails?.fundName, invIdeaScheme?.toString());
    // When modal loads up call below GTM event
    // triggerNomineeModalPageLoadGtmEvent(userFlow.toString(), buyDetails?.fundName, invIdeaScheme?.toString());
  };

  const closeOtpModalGtmData = () => {
    triggerCloseOtpModalGtmEvent(userFlow?.toString(), buyDetails?.fundName, invIdeaScheme?.toString());
  };

  const onGoBackMessageClick = (goBackMessage: string) => {
    triggerGoBackMessageClickGtmEvent(
      userFlow?.toString(),
      buyDetails?.fundName,
      goBackMessage,
      invIdeaScheme?.toString()
    );
  };

  const closeNomineeModalGtmData = () => {
    triggerNomineeModalActionGtmEvent(userFlow?.toString(), buyDetails?.fundName, CLOSE, invIdeaScheme?.toString());
  };

  const submitNomineeModalGtmData = () => {
    triggerNomineeModalActionGtmEvent(
      userFlow?.toString(),
      buyDetails?.fundName,
      CONFIRM_DETAILS,
      invIdeaScheme?.toString()
    );
  };

  const addAnotherNomineeClickGtmData = () => {
    triggerNomineeModalActionGtmEvent(
      userFlow?.toString(),
      buyDetails?.fundName,
      ADD_ANOTHER_NOMINEE,
      invIdeaScheme?.toString()
    );
  };

  const removeNomineeClickGtmData = () => {
    triggerNomineeModalActionGtmEvent(userFlow?.toString(), buyDetails?.fundName, REMOVE, invIdeaScheme?.toString());
  };

  const modeOfOperationSI = () => {
    investmentIdsDetails?.map((item, index) => {
      if (item.mode_of_oper_ac === 'SI') setIsModeOfOperationSI(true);
    });

    // router.push(
    //   routes.TRANSACT_INVEST.url + `&custId=${response ? custId : ''}`
    // );
  };

  const getBuyDetailData = (
    investmentId: string,
    folioNumber: string,
    fundOptionCode?: string,
    lastTransactionId?: string,
    selectedInvestmentId?: InvestmentIdDetails
  ) => {
    API.fetch(API.investments.getBuyDetailsUrl(investmentId, fundOptionCode || (fundCode as string), folioNumber))
      .then((res: BuyDetailsData) => {
        setSelectedInvestmentId(selectedInvestmentId);
        setBuyDetails(res?.data?.data);
        setFundCodeOptionSelected(fundOptionCode || fundCode);
        triggerOnPageLoadGtmEvent(userFlow?.toString(), res?.data?.data?.fundName, invIdeaScheme?.toString());
        setBuyDetailsLoading(false);
      })
      .catch((error) => {
        setOpenErrorModal(true);
        if (error?.errorCode === 7001 || error?.errorCode === 7002 || error?.errorCode === 7082) {
          setOnOkRedirect(true);
          setRedirectTo(fallBackTo as string);
        }
        //for redirecting to portfolio page on Inves
        if (error.errorCode === 7083) {
          setDidErrorOccur(true);
          setOnOkRedirect(true);
          setRedirectTo(routes.PORTFOLIO.url as string);
          // setErrorMessageShownInModal('You hold the investment account in joint mode hence transaction is not allowed. Under Joint mode of holding, transaction allowed only under primary holder’s login');
          setErrorMessageShownInModal(error?.errorMsg?.message);
        } else {
          setDidErrorOccur(true);
          setErrorMessageShownInModal(error?.errorMsg?.message);
        }
      });
  };

  const getBankData = (investmentId: string) => {
    API.fetch(API.investments.getBuyBankDetails(investmentId))
      .then((res: BankData) => {
        const bankDetails = res?.data?.data;
        setBankDetails(convertArrayOfObjectToObject(bankDetails, 'acctId'));
      })
      .catch((error) => {
        if (error?.errorCode === 5004) {
          setErrorOccurredInBankApi(true);
          setErrorMessageOfBankApi(error?.errorMsg?.message);
        } else {
          setErrorMessageShownInModal(error?.errorMsg?.message);
          setOpenErrorModal(true);
        }
      });
  };

  useEffect(() => {
    API.investments
      .getInvestmentIdsUrl()
      .then((investmentIdsData: InvestmentIdsData) => {
        setInvestmentIdsDetails(investmentIdsData?.data?.data);
        // investmentIdSelected is used as one of the conditional check, it helps in triggering the buy details and bankDetails api only once
        // when we don't have investmentIdSelected and we have fetched the data from investmentId's api only then call the buy-details and bank-details api
        if (!hasAlreadyInvested && investmentIdsData?.data?.data?.length > 0 && !investmentIdSelected) {
          if (state.currentInvestmentId) {
            setInvestmentIdSelected(state?.currentInvestmentId);
            getBuyDetailData(
              state?.currentInvestmentId,
              '',
              '',
              '',
              (investmentIdsData?.data?.data?.filter((id, key) => id.inv_ID == state.currentInvestmentId))[0]
            );
            getBankData(state?.currentInvestmentId);
          } else {
            setInvestmentIdSelected(investmentIdsData?.data?.data[0]['inv_ID']);
            getBuyDetailData(investmentIdsData?.data?.data[0]['inv_ID'], '', '', '', investmentIdsData?.data?.data[0]);
            getBankData(investmentIdsData?.data?.data[0]['inv_ID']);
          }
        }
      })
      .catch((err) => {});

    API.investments
      .getRelationShipCodes()
      .then((relationShipCodes: RelationShipCodesData) => {
        const relationShipCodesArray = relationShipCodes?.data?.data;
        setRelationShipCodeDetails(relationShipCodesArray);
        setRelationShipCodeObject(convertArrayOfObjectToObject(relationShipCodesArray, 'description'));
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    // this useEffect is used to call the buy-details and bank-details api if the user is redirected from the holding page, as he already have investment Id, we directly call the below api
    if (investmentId) {
      getBuyDetailData(investmentId as string, folioNumber as string, '', lastTransactionId as string);
      getBankData(investmentId as string);
    }
  }, [investmentId]);

  useEffect(() => {
    if (custId !== '' && selectedInvestmentId && buyDetails) {
      checkConditions();
    }
  }, [selectedInvestmentId, custId, buyDetails]);

  const checkConditions = () => {
    let checkingSecondaryHolderCondition = false;
    let checkingJointHolderCondition = false;
    const checkCompleted = checkIfMultipleInvestmentIds(selectedInvestmentId);
    if (selectedInvestmentId?.mode_of_oper_ac == 'AS' && buyDetails?.folioList[0]?.folioNumber === 'New Folio') {
      checkingJointHolderCondition = true;
    }
    if (selectedInvestmentId?.mode_of_oper_ac == 'AS' && selectedInvestmentId?.cif_id !== custId) {
      checkingSecondaryHolderCondition = true;
    }
    if (selectedInvestmentId) {
      if (checkCompleted) {
        setOpenErrorModal(true);
        setErrorMessageShownInModal(errorMessage.MULTIPLE_INVESTMENT_ID_ERROR);
      } else if (checkingSecondaryHolderCondition) {
        setOpensecondaryHolderInvestmentErrorModal(true);
      } else if (checkingJointHolderCondition) {
        setOpenJointHolderInvestmentErrorModal(true);
      } else if (
        selectedInvestmentId?.mode_of_oper_ac === 'AS' &&
        buyDetails?.folioList?.length !== 0 &&
        selectedInvestmentId?.whetherMFTransactionAllowed === 'Y' &&
        selectedInvestmentId?.cif_id === custId
      ) {
        return;
      } else validateIfCustomerisMinor(selectedInvestmentId);
    }
  };

  const onHandleContinue = (data, isLumpsum) => {
    const transactionData = {
      ...data,
      investmentId: state?.encryptedInvestmentIds[`${data?.investmentId}`],
    };
    triggerContinueClickGtmEvent(
      userFlow.toString(),
      buyDetails?.fundName,
      transactionData,
      isLumpsum,
      invIdeaScheme?.toString()
    );
    setInvestId(data?.investmentId);
    setTransactionRequestData(data);
    setIsLumpsum(isLumpsum);
    setShowPageLoader(true);
    let { accountNumber, ...requestData } = data;
    isLumpsum
      ? API.investments
          .getBuyOneTimeOtp(requestData)
          .then((res: OtpResponseData) => {
            setOtpResponse(res?.data?.data);
            setOpenVerifyOTPModal(true);
            triggerOtpModalPageLoadGtmEvent(userFlow?.toString(), buyDetails?.fundName, invIdeaScheme?.toString());
            setShowPageLoader(false);
          })
          .catch((error) => {
            setOpenErrorModal(true);
            setErrorMessageShownInModal(error?.errorMsg?.message);
            setShowPageLoader(false);
          })
      : API.investments
          .getBuySipOtp(requestData)
          .then((res: OtpResponseData) => {
            setOtpResponse(res?.data?.data);
            setOpenVerifyOTPModal(true);
            triggerOtpModalPageLoadGtmEvent(userFlow?.toString(), buyDetails?.fundName, invIdeaScheme?.toString());
            setShowPageLoader(false);
          })
          .catch((error) => {
            setOpenErrorModal(true);
            setErrorMessageShownInModal(error?.errorMsg?.message);
            setShowPageLoader(false);
          });
  };

  const onHandleAddToCartValidation = (requestData) => {
    if (cartData?.contents?.length === 5) {
      //  if(true) {
      setOpenCartAlertModal(true);
      setErrorMessageShownInModal(MAX_NUMBER_OF_SCHEMES_ALREADY_ADDED);
      return false;
    } else if (cartData?.investmentId && cartData?.investmentId !== requestData?.investmentId) {
      // else if(true) {
      setOpenCartModalForInvestmentId(true);
      setErrorMessageShownInModal(DIFFERENT_INVESTMENTID_ERROR(cartData?.investmentId));
      return false;
    } else {
      return true;
    }
  };

  const onHandleAddToCart = (data, isLumpsum) => {
    //Check if folio has existing nomination
    const transactionData = {
      ...data,
      investmentId: state?.encryptedInvestmentIds[`${data?.investmentId}`],
    };
    setInvestId(data.investmentId);
    setTransactionRequestData(data);
    setIsLumpsum(isLumpsum);
    setShowLoaderAddToCart(true);
    let { accountNumber, ...requestData } = data;

    if (onHandleAddToCartValidation(requestData)) {
      isLumpsum
        ? API.cart
            .getOnetimeAddToCart(requestData)
            .then((res: OtpResponseData) => {
              setShowLoaderAddToCart(false);
              router.push(routes.CART.url);
            })
            .catch((error) => {
              if (error.errorCode === 7077) {
                setOpenCartAlertModal(true);
                setErrorMessageShownInModal(DUPLICATE_FUND_ERROR);
                setShowLoaderAddToCart(false);
              } else {
                setOpenErrorModal(true);
                setErrorMessageShownInModal(error?.errorMsg?.message);
                setShowLoaderAddToCart(false);
              }
            })
        : API.cart
            .getSipAddToCart(requestData)
            .then((res: OtpResponseData) => {
              setShowLoaderAddToCart(false);
              router.push(routes.CART.url);
            })
            .catch((error) => {
              if (error?.errorCode === 7077) {
                setOpenCartAlertModal(true);
                setErrorMessageShownInModal(DUPLICATE_FUND_ERROR);
                setShowLoaderAddToCart(false);
              } else {
                setOpenErrorModal(true);
                setErrorMessageShownInModal(error?.errorMsg?.message);
                setShowLoaderAddToCart(false);
              }
            });
    }
  };

  useEffect(() => {
    if (storedOtp === secondTimeOtop) {
      setErrorMessageShownInModal(errorMessage.INVALID_OTP);
    } else {
      setSecondTimeOtp(storedOtp);
    }
  }, [storedOtp]);

  const onVerifyOtp = (otp: string) => {
    triggerSubmitOtpModalGtmEvent(userFlow?.toString(), buyDetails?.fundName, invIdeaScheme?.toString());
    const requestData = {
      ...transactionRequestData,
      otp: otp,
    };
    // if (Number(transactionRequestData.amount) > bankDetails[transactionRequestData.accountNumber].availableBalance) {
    //   setErrorMessageShownInModal(errorMessage.CUSTOMER_SELECTS_BANK_ACCOUNT_WHICH_DOESNT_HAVE_ENOUGH_BALANCE);
    //   setOpenErrorModal(true);
    // } else {
    if (storedOtp === '' || storedOtp) {
      setStoredOtp(otp);
    }
    setShowLoaderInOtp(true);
    isLumpsum
      ? API.investments
          .getBuyOneTimeOtpVerify(requestData)
          .then((res: LumpsumVerifyOtpData) => {
            const referenceId = res?.data?.data?.mfSubDtlsAutoVerifyRs?.transactionId?.tranId;
            setReferenceId(referenceId);
            setOpenVerifyOTPModal(false);
            setIsTransactionSuccessful(true);
            triggerTransactionSuccessPageLoadGtmEvent(
              userFlow?.toString(),
              buyDetails?.fundName,
              referenceId,
              invIdeaScheme?.toString()
            );
            setShowLoaderInOtp(false);
          })
          .catch((error) => {
            if (error?.errorCode === 7011) {
              setErrorCode(error?.errorCode);
              setOnOkRedirect(true);
              setRedirectTo(routes.MUTUAL_FUND.url);
              setErrorMessageShownInModal(errorMessage.SOMETHING_WHEN_WRONG);
            } else {
              if (otpFailureCount === 2) {
                setOnOkOTPRedirect(true);
              }
              setOtpFailureCount(otpFailureCount + 1);
              setErrorMessageShownInModal(error?.errorMsg?.message);
            }
            setOpenErrorModal(true);
            setShowLoaderInOtp(false);
            setClearOtp(!clearOtp);
          })
      : API.investments
          .getBuySipOtpVerify(requestData)
          .then((res: SIPVerifyOtpData) => {
            const referenceId = res?.data?.data?.mfSystPlanAddVerRs?.sysPlanID;
            setReferenceId(referenceId);
            setOpenVerifyOTPModal(false);
            setIsTransactionSuccessful(true);
            triggerTransactionSuccessPageLoadGtmEvent(
              userFlow.toString(),
              buyDetails?.fundName,
              referenceId,
              invIdeaScheme?.toString()
            );
            setShowLoaderInOtp(false);
          })
          .catch((error) => {
            if (error.errorCode === 7011) {
              setErrorCode(error.errorCode);
              setOnOkRedirect(true);
              setRedirectTo(routes.MUTUAL_FUND.url);
              setErrorMessageShownInModal(errorMessage.SOMETHING_WHEN_WRONG);
            } else {
              if (otpFailureCount === 2) {
                setOnOkOTPRedirect(true);
              }
              setOtpFailureCount(otpFailureCount + 1);
              setErrorMessageShownInModal(error?.errorMsg?.message);
            }
            setOpenErrorModal(true);
            setShowLoaderInOtp(false);
            setClearOtp(!clearOtp);
          });
    // }
  };

  useEffect(() => {
    API.customer
      .getProfile()
      .then((res: any) => {
        setCustId(res?.data?.data[0]?.custId);
      })
      .catch((error) => {
        setErrorMessageShownInModal(error);
        setOpenErrorModal(true);
      });
  }, []);

  const checkIfMultipleInvestmentIds = (selectedIdData: any) => {
    const multipleCifIds = investmentIdsDetails?.filter((invId, index) => {
      if (selectedIdData.cif_id === invId.cif_id) {
        if (selectedIdData.cif_id === custId) {
          return true;
        }
      }
    });
    if (multipleCifIds.length > 1 && selectedIdData.whetherMFTransactionAllowed === 'N') {
      setIsMultipleInvestmentIds(true);
      return true;
    } else {
      setIsMultipleInvestmentIds(false);
      return false;
    }
  };
  //This function is used to obtain the nudge text and appropriate routes to be directed to be shown on success page, based on the scheme fundCategory and whether the scheme
  // is SIP or LUMPSUM
  const SuccessPageNudgesTextAndRoutes = () => {
    let actionButtons = [];
    const nudgesValueObject = constants.NUDGES_BUTTON_TEXT(buyDetails?.fundCategory);
    nudgesValueObject[isLumpsum ? 'LS' : 'SIP'].map((values, index) => {
      actionButtons.push({
        label: values?.label,
        onPress: () => {
          triggerActionButtonsClickGtmEvent(userFlow?.toString(), buyDetails?.fundName, values?.label);
          router.push(values.route, values.asRoute);
        },
      });
    });
    return actionButtons;
  };

  const changeFundOption = (fundCode: string) => {
    setBuyDetailsLoading(true);
    setFundCodeOptionSelected(fundCode);
    getBuyDetailData((investmentId as string) || investmentIdSelected, (folioNumber as string) || '', fundCode, '');
  };

  const changeInvestmentId = (investmentId: string) => {
    const selectedIdData = investmentIdsDetails?.filter((id) => id?.inv_ID == investmentId)[0];
    setSelectedInvestmentId(selectedIdData);
    setBuyDetailsLoading(true);
    setInvestmentIdSelected(investmentId);
    const checkCompleted = checkIfMultipleInvestmentIds(selectedIdData);

    if (checkCompleted) {
      setOpenErrorModal(true);
      setErrorMessageShownInModal(errorMessage.MULTIPLE_INVESTMENT_ID_ERROR);
    } else if (selectedIdData?.isSoleProp === 'Y') {
      if (selectedIdData?.whetherMFTransactionAllowed === 'N') {
        setState({ ...state, solePropId: selectedIdData.cif_id });
        router.push(routes.RISK_PROFILE.url);
      } else {
        router.push(routes.INVEST.url);
      }
    } else if (selectedIdData) {
      if (selectedIdData.isUboApplicable === true) {
        if (selectedIdData?.isSoleProp === 'Y') {
          if (
            selectedIdData?.whetherMFTransactionAllowed === 'N' ||
            (selectedIdData?.whetherMFTransactionAllowed === 'Y' && selectedIdData?.isProfileExpired === 'Y')
          ) {
            setState({ ...state, solePropId: selectedIdData.cif_id });
            router.push(routes.RISK_PROFILE.url);
          }
        } else if (
          selectedIdData.isHUF === 'N' &&
          selectedIdData.whetherMFTransactionAllowed === 'N' &&
          selectedIdData.fatca_AVAILABLE === 'Y' &&
          !checkCompleted
        ) {
          router.push(routes.RISK_PROFILE.url);
        } else if (selectedIdData.isHUF === 'Y') {
          if (selectedIdData.whetherMFTransactionAllowed === 'Y' && selectedIdData.fatca_AVAILABLE === 'N') {
            setOpenErrorModal(true);
            setErrorMessageShownInModal(HUF_INVEST_NOW_ERROR_MESSAGE);
          } else if (selectedIdData.whetherMFTransactionAllowed === 'N' && selectedIdData.fatca_AVAILABLE === 'N') {
            setOpenErrorModal(true);
            setErrorMessageShownInModal(HUF_INVEST_NOW_ERROR_MESSAGE);
          } else if (selectedIdData.whetherMFTransactionAllowed === 'N' && selectedIdData.fatca_AVAILABLE === 'Y') {
            router.push(routes.RISK_PROFILE.url);
          }
        }
      } else {
        setOpenErrorModal(true);
        setErrorMessageShownInModal(errorMessage.UBO_ERROR_MESSAGE);
      }
      getBuyDetailData(investmentId, folioNumber as string, fundCodeOptionSelected as string, '', selectedIdData);
      getBankData(investmentId);
    }
    getBuyDetailData(investmentId, folioNumber as string, fundCodeOptionSelected as string, '', selectedIdData);
    getBankData(investmentId);
  };
  const onBack = () => {
    // triggerOnBackGtmEvent(userFlow.toString(), buyDetails?.fundName, invIdeaScheme?.toString());
    // setState({ ...state, inAppBackPressed: true });
    // router.back();
    if (!!isRenewSip === true) {
      router.push(routes.TRANSACTION.url + `/${investmentId}?showSysTrans=true`);
    } else {
      triggerOnBackGtmEvent(userFlow?.toString(), buyDetails?.fundName, invIdeaScheme?.toString());
      setState({ ...state, inAppBackPressed: true });
      // router.back();
    }
  };

  const redirectedFromPlanYourGoalWithSip = Boolean(isSip);

  // Use this modal footer if you want two buttons in the modal. Currently its used for scenario where user has already added that scheme in cart.
  const ModalTwoButtonFooter = () => (
    <FooterContainer>
      <StyledRow3>
        <StyledButtonCol xs={5.75} sm={5.75} md={2}>
          <StyledButton
            primary
            onClick={() => {
              onViewCartClick();
            }}
          >
            View Cart
          </StyledButton>
        </StyledButtonCol>

        <StyledButtonCol xs={5.75} sm={5.75} md={2}>
          <StyledButton
            primary
            onClick={() => {
              setOpenCartAlertModal(false);
              setShowLoaderAddToCart(false);
            }}
          >
            Cancel
          </StyledButton>
        </StyledButtonCol>
      </StyledRow3>
    </FooterContainer>
  );

  // Use this modal footer if you want single button and wish to pass different name. This Modal Footer is used in add to cart for two scenarios 1. investment ID not matching and already 5 schemes in the cart
  const ModalFooter = (buttonType) => (
    <FooterContainer>
      <ModalFooterWithConfirmation
        confirmMessage={buttonType}
        shouldShowCancel={false}
        onDone={() => (buttonType === 'View Cart' ? onViewCartClick() : onOkClick())}
      />
      <ModalFooterWithConfirmation
        confirmMessage="Cancel"
        shouldShowCancel={false}
        onDone={() => {
          setOpenCartAlertModal(false);
          setShowLoaderAddToCart(false);
        }}
      />
    </FooterContainer>
  );

  const onViewCartClick = () => {
    setShowLoaderAddToCart(false);
    router.push(routes.CART.url);
  };

  const onOkClick = () => {
    setShowLoaderAddToCart(false);
    setOpenCartModalForInvestmentId(false);
  };

  return (
    <InvestPageWrapper>
      {isTransactionSuccessful ? (
        <TransactionSuccessCard
          userFlow={userFlow as string}
          refNo={referenceId}
          schemeName={buyDetails?.fundName}
          amount={transactionRequestData?.amount?.toString()}
          folioNo={transactionRequestData?.folioNum}
          schemeOption={transactionRequestData?.selectedDividendOption}
          sipDate={isLumpsum ? '' : `${getDateOrdinal(transactionRequestData?.scheduleDate)} of every month`}
          transactionType={isLumpsum ? 'Invest' : 'SIP'}
          investmentId={investmentIdSelected as string}
          // sipScheduleDescription={
          //   isLumpsum
          //     ? ''
          //     : `Your next SIP will be debited ${getDateOrdinal(
          //         transactionRequestData.scheduleDate
          //       )} of every month starting from ${getDateOrdinal(new Date(buyDetails.valueDate).getDate())} ${
          //         Months[new Date(buyDetails.valueDate).getMonth()]
          //       } ${new Date(buyDetails.valueDate).getFullYear()}`
          // }
          sipScheduleDescription=""
          isElss={buyDetails?.fundSubCategory === SAVE_TAX_SUB_CAT}
          isLumpsum={isLumpsum}
          transactionSource={hasAlreadyInvested ? 'holdings' : 'mutualFund'}
          actionButtons={SuccessPageNudgesTextAndRoutes()}
          noOfInstallments={
            isLumpsum
              ? ''
              : transactionRequestData?.noOfInstallment === -1
              ? 'Until Cancelled'
              : transactionRequestData?.noOfInstallment
          }
          queryParam={investId}
          onGoBackMessageClick={onGoBackMessageClick}
          isNfo={!!isNfo}
        />
      ) : (
        <>
          {openJointHolderInvestmentErrorModal && (
            <StyledAlertModal
              className="alert-modal"
              wrapperClassname="alert-modal-wrapper"
              contentClassname="alert-modal-content"
              onClose={() => {
                if (stallJointInvestmentIdError) {
                  setOpenJointHolderInvestmentErrorModal(false);
                  setOpensecondaryHolderInvestmentErrorModal(false);
                } else {
                  setOpenJointHolderInvestmentErrorModal(false);
                  setState({ ...state, currentInvestmentId: null });
                  router.push(routes.MUTUAL_FUND.url);
                }
              }}
              mode="alert"
              showHeader={false}
            >
              <StyledP1 dangerouslySetInnerHTML={{ __html: JOINT_INVESTMENT_ID_ERROR }} />
            </StyledAlertModal>
          )}

          {openSecondaryHolderInvestmentErrorModal && (
            <StyledAlertModal
              className="alert-modal"
              wrapperClassname="alert-modal-wrapper"
              contentClassname="alert-modal-content"
              onClose={() => {
                setOpensecondaryHolderInvestmentErrorModal(false);
                setState({ ...state, currentInvestmentId: null });
                router.push(routes.PORTFOLIO.url);
              }}
              mode="alert"
              showHeader={false}
            >
              <StyledP1 dangerouslySetInnerHTML={{ __html: SECONDARY_HOLDER_INVESTMENT_ID_ERROR }} />
            </StyledAlertModal>
          )}
          {minorTurnedMajorCustomErrorModalOpen && (
            <StyledAlertModal
              className="alert-modal"
              wrapperClassname="alert-modal-wrapper"
              contentClassname="alert-modal-content"
              onClose={() => {
                setMinorTurnedMajorCustomErrorModalOpen(false);
              }}
              mode="alert"
              showHeader={false}
            >
              <StyledP1 dangerouslySetInnerHTML={{ __html: errorMessage.MINOR_TURNS_MAJOR_ERROR }} />
            </StyledAlertModal>
          )}
          {openErrorModal && (
            <StyledAlertModal
              className="alert-modal"
              wrapperClassname="alert-modal-wrapper"
              contentClassname="alert-modal-content"
              onClose={() => {
                onOkRedirect
                  ? router.push(redirectTo || routes.MUTUAL_FUND.url)
                  : onOkOTPRedirect
                  ? onBack()
                  : setOpenErrorModal(false);
                setShowLoaderAddToCart(false);
              }}
              mode="alert"
              showHeader={false}
            >
              <StyledP1 dangerouslySetInnerHTML={{ __html: errorMessageShownInModal }} />
            </StyledAlertModal>
          )}

          {/* For Add to Cart Modals with two buttons we are using this modal, this includes error when scheme is already added to the cart OR If user is adding more than 5 schemes */}
          {openCartAlertModal && (
            <StyledModalWithTwoButtons
              className="alert-modal"
              wrapperClassname="alert-modal-wrapper"
              contentClassname="alert-modal-content"
              showHeader={false}
              FooterComponent={ModalTwoButtonFooter()}
            >
              <StyledP1 dangerouslySetInnerHTML={{ __html: errorMessageShownInModal }} />
            </StyledModalWithTwoButtons>
          )}

          {/* This Modal is used for add to cart, If user is using some other investment Id instead of the one he has already invested with. */}
          {openCartModalForInvestmentId && (
            <StyledAlertModal
              className="alert-modal"
              wrapperClassname="alert-modal-wrapper"
              contentClassname="alert-modal-content"
              onClose={() => {
                setOpenCartModalForInvestmentId(false);
                setShowLoaderAddToCart(false);
              }}
              mode="alert"
              showHeader={false}
            >
              <StyledP1 dangerouslySetInnerHTML={{ __html: errorMessageShownInModal }} />
            </StyledAlertModal>
          )}

          <StyledRow>
            <BackButtonWrapper headerHeight={headerHeight}>
              <StyledCol xs={12}>
                <Container fullWidthInMobile>
                  <HeaderItemsWrapper>
                    <BackButton title={constants.BACK} onBack={onBack} />
                    <Link href={`${routes.CART.url}`}>
                      <CartIconWrapper>
                        <CartContainer enableCart={true}>
                          {getIconForNavigationTab('CartSvg')}
                          {state?.cartSchemeCount ? <CartCounter>{state?.cartSchemeCount}</CartCounter> : ''}
                        </CartContainer>
                      </CartIconWrapper>
                    </Link>
                  </HeaderItemsWrapper>
                </Container>
              </StyledCol>
            </BackButtonWrapper>
            <StyledCol xs={12}>
              <Container>
                {buyDetails && bankDetails && investmentIdsDetails ? (
                  <InvestPage
                    hasAlreadyInvested={!!hasAlreadyInvested}
                    fundCode={fundCode as string}
                    folioNumber={folioNumber as string}
                    investmentId={investmentId as string}
                    isNfo={!!isNfo}
                    bankDetails={bankDetails}
                    mobileNumber={otpResponse?.mobileNo}
                    emailId={otpResponse?.emailId}
                    setOpenJointHolderInvestmentErrorModal={setOpenJointHolderInvestmentErrorModal}
                    setOpensecondaryHolderInvestmentErrorModal={setOpensecondaryHolderInvestmentErrorModal}
                    setStallJointInvestmentIdError={setStallJointInvestmentIdError}
                    stallJointInvestmentIdError={stallJointInvestmentIdError}
                    redirectedFromPlanYourGoalWithSip={redirectedFromPlanYourGoalWithSip}
                    isRenewSip={!!isRenewSip}
                    schedule={schedule}
                    frequency={frequency}
                    changeFundOption={changeFundOption}
                    fundCodeOptionSelected={fundCodeOptionSelected as string}
                    userFlow={userFlow?.toString()}
                    invIdeaScheme={invIdeaScheme?.toString()}
                    isCustomerMinor={isCustomerMinor}
                    setMinorTurnedMajorCustomErrorModalOpen={setMinorTurnedMajorCustomErrorModalOpen}
                    selectedInvestmentId={selectedInvestmentId}
                    {...{
                      buyDetails,
                      onHandleContinue,
                      onHandleAddToCart,
                      showLoaderAddToCart,
                      clearOtp,
                      onVerifyOtp,
                      investmentIdsDetails,
                      showPageLoader,
                      showLoaderInOtp,
                      setOpenVerifyOTPModal,
                      openVerifyOTPModal,
                      buyDetailsLoading,
                      changeInvestmentId,
                      investmentIdSelected,
                      relationShipCodeDetails,
                      relationShipCodeObject,
                      errorOccurredInBankApi,
                      errorMessageOfBankApi,
                      termsAndConditionGtmData,
                      addNomineeGtmData,
                      editNomineeGtmData,
                      closeOtpModalGtmData,
                      closeNomineeModalGtmData,
                      submitNomineeModalGtmData,
                      addAnotherNomineeClickGtmData,
                      removeNomineeClickGtmData,
                    }}
                  />
                ) : (
                  !didErrorOccur && (
                    <DotLoaderWrapper>
                      <StyledDotLoader large={true} primary />
                    </DotLoaderWrapper>
                  )
                )}
              </Container>
            </StyledCol>
            {showLoaderInOtp && <FullPageLoader />}
            <StyledCol xs={12}>
              <Footer hasNavigationBar />
            </StyledCol>
          </StyledRow>
        </>
      )}
    </InvestPageWrapper>
  );
}

const InvestPageWrapper = styled.div``;

const StyledDotLoader = styled(DotLoader)`
  margin-top: ${pxToRem(60)};
  ${up('md')} {
    margin-top: ${pxToRem(60)};
  }
`;

const DotLoaderWrapper = styled.div`
  text-align: center;
`;

const StyledRow = styled(Row)`
  padding: 0;
  margin: 0;
`;

const StyledCol = styled(Col)`
  padding: 0;
  margin: 0;
`;

const BackButtonWrapper = styled.article<{ headerHeight: string }>`
  position: sticky;
  top: ${(props) => props.headerHeight};
  background-color: #f6f7f8;
  z-index: 2;
  width: 100%;
`;

const StyledP1 = styled(P1)`
  color: #6d6e71;
`;

export const StyledAlertModal = styled(Modal)`
  .alert-modal-wrapper {
    display: flex;
  }

  .alert-modal-content {
    align-self: center;
    margin: 0 auto;
    left: 0;
  }
`;

const HeaderItemsWrapper = styled.article`
  display: flex;
  justify-content: space-between;
  padding-top: ${pxToRem(6)};
`;

const CartIconWrapper = styled.article`
  cursor: pointer;
  align-self: center;
  padding-right: ${pxToRem(6)};
  position: relative;
`;

const CartContainer = styled.article<{ enableCart?: boolean }>`
  position: relative;
  display: ${(props) => (props.enableCart ? 'flex' : 'none')};
  padding: 0 ${pxToRem(8)} 0 0;
`;
const CartCounter = styled(P2)`
  position: absolute;
  left: ${pxToRem(24)};
  bottom: ${pxToRem(24)};
  border-radius: ${pxToRem(50)};
  width: ${pxToRem(16)};
  height: ${pxToRem(14)};
  color: ${(props) => props.theme.palette.white};
  line-height: ${pxToRem(12)};
  font-size: ${pxToRem(10)};
  text-align: center;
  background-color: #4a4a4a;
  display: ${(props) => (props.disableNotificationCount ? 'none' : 'inline')};
`;

const StyledRow3 = styled(Row)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${up('md')} {
    flex-direction: row;
    justify-content: flex-end;
    gap: 8px;
    margin-right: 5px;
  }
`;

export const StyledModalWithTwoButtons = styled(Modal)`
  ${down('md')} {
    .alert-modal-wrapper {
      display: flex;
    }
    .alert-modal-content {
      align-self: center;
      margin: 0 1em;
      position: relative;
      top: 40%;
      padding: 0 auto;
    }
  }
  ${up('md')} {
    .alert-modal-wrapper {
      display: flex;
    }
    .alert-modal-content {
      align-self: center;
      margin: 0 auto;
      left: 0;
    }
  }
`;
export const StyledModalForInvestmentIdError = styled(Modal)`
  text-align: center;
`;
const FooterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  ${up('md')} {
    margin: 0;
    text-align: center;
  }
`;

const StyledB1 = styled(B1)``;

const RefId = styled.span`
  color: #97144d;
  font-weight: bold;
`;

const StyledButtonCol = styled(Col)`
  padding: 8px 0px;
  margin: 0;
`;

const StyledButton = styled(Button)``;
